import React from "react";
import {
  FaReact,
  FaHandPointRight,
  FaDatabase,
  FaMapMarkerAlt,
  FaEnvelope,
  FaDownload,
  FaPhoneAlt,
  FaNodeJs,
  FaTools,
} from "react-icons/fa";
import { SiRubyonrails } from "react-icons/si";

const data = {
  homeDetails:
    "Full Stack Developer with a passion for building beautiful and functional websites.",
  homeTitle: "Welcome to my personal portfolio",
  projectTitle: "Projects",
  technoTitle: "Technologies",
  download: <FaDownload />,
  technoInfo:
    "I have a wide range of skills in the field of web and mobile apps development. I have experience in building websites and mobile apps using HTML, CSS, JavaScript, React, React Native, Node.js, Express, MongoDB, MySQL, and more.",
  titleAbout: "About me",
  infoAbout:
    "I'm Mwafrika Josué, a software developer specializing in various technologies. I create web applications, mobile apps, and visually appealing websites for businesses. I enjoy delving into difficult problems as well as learning new languages and technologies.",
  imageAbout:
    "https://res.cloudinary.com/ujuzi/image/upload/v1653783195/mes%20documents/IMG_4892_gqppaj.jpg",
  cards: [
    {
      id: 1,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1670286381/Kevent/huntify_iw4jnf.png",
      alt: "react",
      title: "Huntify",
      technologies: ["MERN Stack", "Context API", "Styled-components"],
      info: " Huntify Tracks your job applications and keep your job search organized, all in one place. No more spreadsheets, no more emails,no more lost job applications.",
      code: "https://github.com/mwafrika/jobifyMev2",
      live: "https://huntify.netlify.app",
    },
    {
      id: 2,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1650097658/portfolio_images/kevent_n9ilbw.png",
      alt: "react",
      title: "Kevent",
      technologies: ["React", "TypeScript", "Redux", "Tailwind", "Node.js"],
      info: "Kevent is a full-stack tourism software that helps you find the best places to visit in your area based on your preferences.",
      code: "https://github.com/mwafrika/kevent-web-second",
      live: "https://www.kevent-rdc.com/",
    },
    {
      id: 3,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1650092446/portfolio_images/FireShot_Capture_008_-_CMS_Blog_-_blog-with-cms.vercel.app_w3pkph.png",
      alt: "react",
      title: "GraphCMS",
      technologies: ["NextJS", "Tailwind CSS", "GraphQL", "GraphCMS"],
      info: "A blog project with featured, recent posts and categories. full markdown articles, author information, comments, and much more, this is a fully responsive CMS Blog Application.",
      code: "https://github.com/mwafrika/GraphCMS-Blog",
      live: "https://blog-with-cms.vercel.app/",
    },
    {
      id: 4,
      icon: <SiRubyonrails />,
      image:
        "https://www.ecranlarge.com/uploads/image/001/350/walker-texas-ranger-photo-chuck-norris-1350724.JPG",
      alt: "React native",
      title: "Chuck Noris App",
      technologies: ["React Native", "TypeScript", "Styled-component"],
      info: "App that displays the most current and random chuck norris jokes based on the available categories",
      code: "https://github.com/mwafrika/chuck-test-sovetech",
      live: "https://res.cloudinary.com/ujuzi/video/upload/v1660853712/XRecorder_18082022_215959_lrkth0.mp4",
    },
    {
      id: 5,
      icon: <FaReact />,
      image: "https://i.ibb.co/BK1Hn0x/Screenshot-2022-08-08-at-4-05-48-PM.png",
      alt: "react",
      title: "Landing page",
      technologies: ["React", "Tailwind", "Vite"],
      info: "A complete modern website (landing page) using React, TailwindCSS and Vite",
      code: "https://github.com/mwafrika/Modern-landing-page",
      live: "https://modern-landing-page2.netlify.app/",
    },
    {
      id: 6,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1653778062/mes%20documents/space-traveller_uwn1w3.png",
      alt: "react",
      title: "Space Traveller Hub",
      technologies: ["React", "redux-thunk", "CSS-module"],
      info: "A web application that displays real-time data from the SpaceX API. Users can book rockets, and dragons, and join selected space missions. You may also cancel any reservations that you wish.",
      code: "https://github.com/mwafrika/space_traveller_hub",
      live: "https://space-traveller.netlify.app/",
    },
  ],
  technologies: [
    {
      id: 1,
      icon: <FaReact />,
      point: <FaHandPointRight />,
      title: "Frontend",
      list: [
        "React",
        "React-Native",
        "PWA",
        "Redux",
        "Javascript",
        "HTML5, CSS3",
        "Tailwind, Material-UI, Bootstrap",
        "Next.js",
      ],
    },
    {
      id: 2,
      icon: <FaNodeJs />,
      point: <FaHandPointRight />,
      title: "Backend",
      list: ["Node.js/Express", "Ruby", "Ruby on rails", "Nest.js", "Next.js"],
    },
    {
      id: 3,
      icon: <FaDatabase />,
      point: <FaHandPointRight />,
      title: "Database & ORM",
      list: ["Postgres", "MySQL", "MongoDB", "Sequelize", "TypeORM", "Prisma"],
    },
    {
      id: 4,
      icon: <FaTools />,
      point: <FaHandPointRight />,
      title: "Tools",
      list: [
        "Postman",
        "Git, Github",
        "Webpack",
        "Heroku",
        "Digital Ocean",
        "Netlify",
        "Jest, Mocha, Chai",
      ],
    },
  ],
  contact: {
    title: "Contact me",
    subTitle: "Let’s get in touch",
    info: "I'm always open to new opportunities and collaborations. If you have any questions, feel free to reach out to me.",
    list: [
      {
        id: 1,
        icon: <FaMapMarkerAlt className="dark:text-blue-600" />,
        title: "Kigali - Rwanda",
      },
      {
        id: 2,
        icon: <FaEnvelope className="dark:text-blue-600" />,
        title: "mwafrikajosue@gmail.com",
      },
      {
        id: 3,
        icon: <FaPhoneAlt className="dark:text-blue-600" />,
        title: "(+243) 995220038",
      },
    ],
  },
  menu: [
    {
      id: 1,
      name: "Home",
      url: "/#home",
    },
    {
      id: 2,
      name: "About",
      url: "/#about",
    },
    {
      id: 3,
      name: "Projects",
      url: "/#projects",
    },
    {
      id: 4,
      name: "Technologies",
      url: "/#tech",
    },
    {
      id: 5,
      name: "Contact",
      url: "/#contact",
    },
  ],
};

export default data;
